/**
 * Výpočet barvy leadu podle stáří bez reakce (bílá → červená škála)
 * 
 * Prahy:
 * - do 1h: bílá (#ffffff)
 * - do 4h: velmi lehce růžová
 * - do 8h: lehce růžová
 * - do 24h: růžová/světle červená
 * - do 48h: červená
 * - 48h+: tmavě červená
 */

export interface LeadAgeInfo {
  backgroundColor: string;
  indicatorColor: string;
  textColor: string;
  label: string;
  hoursWithoutTouch: number;
  isUrgent: boolean;
}

export function getLeadAgeColor(
  createdAt: string,
  lastTouchAt?: string | null
): LeadAgeInfo {
  const now = new Date();
  const referenceDate = lastTouchAt ? new Date(lastTouchAt) : new Date(createdAt);
  const diffMs = now.getTime() - referenceDate.getTime();
  const diffHours = diffMs / (1000 * 60 * 60);

  let indicatorColor: string;
  let label: string;
  let isUrgent = false;

  if (diffHours <= 1) {
    indicatorColor = '#10b981'; // green-500 - čerstvý
    label = 'Čerstvý';
  } else if (diffHours <= 4) {
    indicatorColor = '#84cc16'; // lime-500
    label = `${Math.floor(diffHours)}h`;
  } else if (diffHours <= 8) {
    indicatorColor = '#eab308'; // yellow-500
    label = `${Math.floor(diffHours)}h`;
  } else if (diffHours <= 24) {
    indicatorColor = '#f97316'; // orange-500
    label = `${Math.floor(diffHours)}h`;
    isUrgent = true;
  } else if (diffHours <= 48) {
    indicatorColor = '#ef4444'; // red-500
    label = `${Math.floor(diffHours / 24)}d ${Math.floor(diffHours % 24)}h`;
    isUrgent = true;
  } else {
    indicatorColor = '#dc2626'; // red-600
    const days = Math.floor(diffHours / 24);
    label = `${days}d`;
    isUrgent = true;
  }

  return {
    backgroundColor: '#ffffff', // vždy bílé pozadí
    indicatorColor,
    textColor: '#374151', // gray-700
    label,
    hoursWithoutTouch: diffHours,
    isUrgent,
  };
}

export function formatLeadAge(createdAt: string): string {
  const now = new Date();
  const created = new Date(createdAt);
  const diffMs = now.getTime() - created.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMinutes < 60) {
    return `${diffMinutes}m`;
  }
  if (diffHours < 24) {
    return `${diffHours}h`;
  }
  if (diffDays < 7) {
    return `${diffDays}d`;
  }
  return `${Math.floor(diffDays / 7)}t`;
}
